import React, { useMemo } from "react";
import { Container, Filters } from "./styles";
import Select from "./components/Select";
import DateRange from "./components/DateRange";
import useFetcher from "../../../../../hooks/useFetcher";
import { fetchRegiones } from "../../../../../services/regionServices";
import { fetchSucursales } from "../../../../../services/sucursalServices";
import { fetchPiAsignable } from "../../../../../services/ticketingServices";
import { fetchCustomers } from "../../../../../services/reportingServices";

const Component = ({ currentFilters, initialFilters, addFilter, removeFilter, groupBy }) => {
  const [regiones, isLoadingRegiones] = useFetcher(fetchRegiones);
  const [sucursales, isLoadingSucursales] = useFetcher(fetchSucursales);
  const [clientes, isLoadingClientes] = useFetcher(fetchCustomers);
  const [asignados, isLoadingAsignados] = useFetcher(fetchPiAsignable);

  const availablesFilters = useMemo(() => {
    const selectedRegion = currentFilters.region;
    let selectedSucursal;

    if (currentFilters.sucursal) {
      selectedSucursal = (sucursales || []).find((item) => item.itemId === currentFilters.sucursal[0]);

      if (selectedSucursal && selectedSucursal.region2 !== currentFilters.region) {
        addFilter([{ key: "region", value: selectedSucursal.region2 }]);
      }
    }

    return [
      {
        label: "Region",
        id: "region",
        type: "select",
        options: (regiones || [])
          .filter((item) => !selectedSucursal || (!!selectedSucursal && item.itemId === selectedSucursal.region2))
          .map((item) => ({ value: item.itemId, label: item.title })),
        loading: isLoadingRegiones,
        placeholder: "Selecciona...",
        props: {
          isMulti: false,
        },
      },
      {
        label: "Sucursal",
        id: "sucursal",
        type: "select",
        options: (sucursales || [])
          .filter((item) => !selectedRegion || (!!selectedRegion && item.region2 === selectedRegion))
          .map((item) => ({ value: item.itemId, label: item.titulo })),
        loading: isLoadingSucursales,
        placeholder: "Selecciona...",
        props: {
          isMulti: true,
        },
      },
      {
        label: "Asignado",
        id: "asignado",
        type: "select",
        options: (asignados || []).map((item) => ({ value: item.itemId, label: item.nombreApellido })),
        loading: isLoadingAsignados,
        placeholder: "Selecciona...",
        props: {
          isMulti: false,
        },
      },
      {
        label: "Cliente",
        id: "cliente",
        type: "select",
        options: (clientes || []).map((item) => ({ value: item, label: item })),
        placeholder: "Selecciona...",
        props: {
          isMulti: false,
        },
      },
      {
        label: "Rango de fechas",
        id: "rango-de-fechas",
        type: "date-range",
        options: null,
        placeholder: "Selecciona...",
        props: {},
      },
    ];
  }, [regiones, isLoadingRegiones, sucursales, isLoadingSucursales, asignados, isLoadingAsignados, clientes, isLoadingClientes, currentFilters]);

  return (
    <Container>
      <Filters>
        {availablesFilters.map((filter) => {
          const typeOfField = filter.type;

          switch (typeOfField) {
            case "select":
              return (
                <Select
                  currentFilters={currentFilters}
                  initialFilters={initialFilters}
                  filter={filter}
                  addFilter={addFilter}
                  removeFilter={removeFilter}
                  groupBy={groupBy}
                  {...filter.props}
                />
              );
            case "date-range":
              return (
                <DateRange
                  currentFilters={currentFilters}
                  initialFilters={initialFilters}
                  filter={filter}
                  addFilter={addFilter}
                  removeFilter={removeFilter}
                  groupBy={groupBy}
                />
              );
            default:
              return <></>;
          }
        })}
      </Filters>
    </Container>
  );
};

export default Component;
